import { NgModule } from '@angular/core'
import { CustomTableModule } from './custom-table/custom-table.module'
import { CustomErrorModule } from './custom-error/custom-error.module'
import { CustomSelectModule } from './custom-select/custom-select.module'
import { CustomButtonModule } from './custom-button/custom-button.module'
import { CustomSearchInputModule } from './custom-search-input/custom-search-input.module'

@NgModule({
  exports: [CustomTableModule, CustomErrorModule, CustomSelectModule, CustomButtonModule, CustomSearchInputModule],
  imports: [CustomTableModule, CustomErrorModule, CustomSelectModule, CustomButtonModule, CustomSearchInputModule]
})
export class CustomComponentsModule {}
